import { defineStore } from "pinia";
import { eventService } from "@/_services";

export const eventStore = defineStore("event", {
  state: () => ({
    events: null,
    eventsExport: null,
    event: null,
    eventCreated: null,
    eventUpdated: null,
    eventDeleted: null,
    error: null,
  }),

  actions: {
    getEvents(pagination, query, sort) {
      this.error = null;
      eventService
        .getEvents(pagination, query, sort)
        .then((result) => {
          this.events = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.eventsExport = null;
      return eventService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.eventsExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getEventById(event_id) {
      this.error = null;
      this.event = null;
      eventService
        .getEventById(event_id)
        .then((result) => {
          this.event = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    createEvent(data) {
      this.error = null;
      this.eventCreated = null;
      eventService
        .createEvent(data)
        .then((result) => {
          this.eventCreated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateEvent(data, event_id) {
      this.error = null;
      this.eventUpdated = null;
      eventService
        .updateEvent(data, event_id)
        .then((result) => {
          this.eventUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    deleteEvent(event_ids) {
      this.error = null;
      this.eventDeleted = null;
      eventService
        .deleteEvent(event_ids)
        .then((result) => {
          this.eventDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
